import { render, staticRenderFns } from "./OnboardingPhotoUpdate.vue?vue&type=template&id=4d381f2c&"
import script from "./OnboardingPhotoUpdate.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports